<template>
    <div id="basic-card" class="home-page">
        <div class="vx-row">
            <div class="loader-block loader-block2" v-if="isLoading">
                <div class="loading">
                    <div class="effect-1 effects"></div>
                    <div class="effect-2 effects"></div>
                    <div class="effect-3 effects"></div>
                </div>
            </div>
            <h2 class="vx-col w-full" style="text-align: center; margin: 0 0 20px 0">Duplicates results</h2>
            <template v-if="!isLoading">
                <div class="vx-col custom-asset-card mb-base w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5 xl:w-1/6" v-for="(item, index) in items" :key="index" v-if="items && items.length">
                    <router-link
                            :to="$store.state.user.role.name === 'Authenticated' ? ('/' + item._id) : ('/' + item._id + '/edit')"
                    >
                        <vx-card>
                            <div slot="no-body" class="card-img-block">
                                <div class="asset-img-section">
                                    <img :src="item.thumbnail ? item.thumbnail : $root.getDefaultThumbnail(item.asset_type)" alt="content-img" class="responsive card-img-top" v-if="showImages">
                                </div>
                                <vs-chip
                                        :color="item.asset_type === 'video' ? 'danger' : item.asset_type === 'image' ? 'success' : 'primary'"
                                        class="item-category">{{ getTypeName(item) }}
                                </vs-chip>
                                <vs-chip color="primary" class="item-type" v-if="item.variants && item.variants.length && item.variants.length > 1">{{ item.variants.length }}</vs-chip>
                            </div>
                            <h5 class="mb-2">{{ item.title }}</h5>
                            <p class="text-grey asset-desc">{{ item.description }}</p>
                        </vx-card>
                    </router-link>
                </div>
                <h3 class="vx-col w-full" style="text-align: center;margin-top: 20px" v-if="!items || !items.length">
                    No items found
                </h3>

            </template>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'Duplicates',
        components: {},
        head() {
            return {
                title: {
                    inner: 'AMP',
                    separator: ' ',
                    complement: ''
                },
                meta: [
                    {hid: 'description', name: 'description', content: ''}
                ]
            }
        },
        data() {
            return {
                orderBy: {
                    'order': 'desc',
                    'order_by': 'updatedAt'
                },
                searchQuery: '',
                isLoading: false,
                debounce: false,
                items: [],
                types: this.$store.state.types,
                showImages: false,
            }
        },
        computed: {},
        mounted() {
            this.search();
        },
        methods: {
            search() {
                this.isLoading = true;
                this.showImages = false;
                let url = '/assets/duplicates';

                this.$axios.get(url).then(res => {
                    this.items = res.data;
                    this.isLoading = false;
                    setTimeout(() => {
                        this.showImages = true;
                    }, 100)
                }).catch(e => {
                    this.isLoading = false;
                    this.showImages = true;
                    console.log('catch_search', e)
                });
            },
            getTypeName(item) {
                if (!item.asset_type) return "";
                return this.$store.state.assetTypes[item.asset_type] || "";
            },
        },
    }
</script>

<style lang="scss">
    #demo-basic-card {
        .overlay-card {
            .vx-card__collapsible-content {
                max-height: 485px;
            }
        }

        .chat-card-log {
            height: 360px;

            .chat-sent-msg {
                background-color: #f2f4f7 !important;
            }
        }

        .card-video {
            .video-js {
                height: 370px;
            }
        }
    }
</style>
